<template>
	<div v-show="bodyIsShow">
		<div v-if="autoShowInfo.tAutoshowPeriodsOcpc != null">
			 <input type="hidden" id="ocpcId" name="ocpcId" :value="autoShowInfo.tAutoshowPeriodsOcpc.ocpcId" />
            <input type="hidden" id="promotionCanal" name="promotionCanal" :value="autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal" />
		</div>
		<input type="hidden" id="showAddress" :value="showAddress">
		<div class="bigbodywrap">
			<section>
				<div class="banner clearfix">
					<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl +'/'+ autoShowInfo.headerImg" />
				</div>
			</section>
			<section>
				<div class="processwrap clearfix">
					<div class="fastknow clearfix">
						<div class="left-wrap">
							<!--<a class="trackEvent" data-track="carfestivalDetail-1-linkToServe" href="#ensure">-->
							<a class="trackEvent" data-track="carfestivalDetail-1-linkToServe" href="javascript:void(0);">
								<div class="answer">
									<em class="icon-left"></em>为什么在惠民团车节购车比平时省约
									<em class="red-size">10%</em>
								</div>
							</a>
							<div v-if="autoShowInfo.applyprocessList && autoShowInfo.applyprocessList.length > 0 && (autoShowInfo.showApplyprocess == true)" class="clearfix tickwrap">
								<ul class="tickwrap-in">
										<li v-for="(item,index) in autoShowInfo.applyprocessList" :class="'tick0'+index">
											<em></em>{{item.text}}</li>
								</ul>
							</div>
							<img v-else width="100%" :src='commmonWebConfig.static+"/img/carfestival/ticketimg.png"'></img>
								
						</div>
					</div>
				</div>
				<div v-if="autoShowInfo && (autoShowInfo.showCountdown == true)" class="count-timer">
					<input type="hidden" id="timeVal" :value="deadline" />
					<ul class="showtime clearfix" id="showTime">
						<li class="timer">
							<em>
								<span v-if="isShowTmallUrl != 1">免费</span>领票倒计时：</em>
						</li>
						<li>
							<em class="redsize day">00</em>
						</li>
						<li>
							<em>天</em>
						</li>
						<li>
							<em class="redsize hour">00</em>
						</li>
						<li>
							<em>时</em>
						</li>
						<li>
							<em class="redsize min">00</em>
						</li>
						<li>
							<em>分</em>
						</li>
						<li>
							<em class="redsize sec">00</em>
						</li>
						<li>
							<em>秒</em>
						</li>
					</ul>
				</div>
			</section>
			<section id="formwrapSection" class="formwrapSection clearfix">
				<div class="titletick">
					<span class="titleIn-em-red">
						<em></em>预约领票</span>
				</div>
				<div class="formwrap">
					<form id="signUpfrom" class="signUpfrom" action="/hmtcj/applyForTcj" method="post">
						<input type="hidden" id="groupbyNum" name="groupbyNum" :value="periodsInfo.id" />
						<input type="hidden" id="position" name="position" value="1" />
						<input type="hidden" id="groupbyType" name="groupbyType" value="1" />
						<div class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon03"></em>
							<div  @click="getData($event)" id="insertCar" class="signUpfrom-txt">请选择意向品牌和意向车型</div>
							<em class="icon-arror-marsk"></em>
						</div>
						<div class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon01"></em>
							<input id="userName" name="userName" placeholder="请输入姓名" class="signUpfrom-txt userName" type="text" maxlength="10" />
						</div>
						<div class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon02"></em>
							<input id="telphone" name="telphone" placeholder="请输入手机号码" class="signUpfrom-txt telphone" type="tel" maxlength="11" />
						</div>
						<div v-if="showAddress == 1" class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon04"></em>
							<input id="address" name="address" placeholder="请输入门票快递收件地址" class="signUpfrom-txt address" type="text" maxlength="200" />
						</div>
						<div class="signUpform-com code-warp">
							<em class="signUpfrom-icon signUpfrom-icon03"></em>
							<input id="code" name="code" placeholder="请输入验证码" class="signUpfrom-txt code" type="tel" maxlength="4" />
							<button type="button" id="code-btn" class="code-btn">获取验证码</button>
						</div>
						<div class="sub-wrap">
							<div @click="subApplyBtn('#insertCar')" data-track="carfestivalDetail-1-linkToServe" :class="['trackEvent','tikect-btn',{'noclick':isclick}]">
									<span v-if="isShowTmallUrl != 1" class="money">&yen;{{periodsInfo.ticketPrice}}
										<em class="number"></em>
									</span>
									立即<span v-if="isShowTmallUrl != 1">免费</span>领票
							</div>
						</div>
						<div data-track="carfestivalDetail-3-signUpFixed" id="tikect-btn-fixed" class="trackEvent tikect-btn-fixed">
								<span v-if="isShowTmallUrl != 1" class="money">&yen;{{periodsInfo.ticketPrice}}
									<em class="number"></em>
								</span>
								点击<span v-if="isShowTmallUrl != 1">免费</span>领票
						</div>
						<div style="margin-bottom:1em;color:#999" class="addxyroom">*请放心填写,报名即视为同意<a href="javascript:void(0);" class="addxydetail"  @click="addxydetail">《个人信息保护声明》</a> </div>
					</form>
				</div>
				<section>
					<div v-if="autoShowInfo.showApplynum == true" class="music-bigwrap clearfix">
						<div class="musicsize">已有
							<em>{{appPersonNum}}</em>人领取门票</div>
						<div id="music" class="music clearfix">
							<div class="musicicon"></div>
							<div id="showPerson" class="showPerson">
									<ul v-if="applyListMap.length > 0" class="musiclist">
											<li v-for="(item,index) in applyListMap" class="name">
												<span>{{item.username}}</span>
												<span>{{item.userphone}}</span>
												<span>已<span v-if="isShowTmallUrl != 1">免费</span>领票</span>
											</li>
									</ul>
							</div>
						</div>
					</div>
					<div v-else class="music-bigwrap music-bigwrapNoNum clearfix">
						<div id="music" class="music clearfix">
							<div class="musicicon"></div>
							<div id="showPerson" class="showPerson">
									<ul v-if="applyListMap.length > 0" class="musiclist">
											<li v-for="(item,index) in applyListMap"  class="name">
												<span>{{item.username}}</span>
												<span>{{item.userphone}}</span>
												<span>已<span v-if="isShowTmallUrl != 1">免费</span>领票</span>
											</li>
									</ul>
							</div>
						</div>
					</div>
				</section>
				<!--广告位-->
				<section v-if="adSpaceObj != null" id="showBanner" class="showBanner">
					<img :data-isshowpop="adSpaceObj.labelDesc" :data-gotolink="adSpaceObj.text" data-track="carfestivalDetail-10-linkToAd"
					 class="scrollLoading trackEvent" v-lazy="commmonWebConfig.picHost+adSpaceObj.imageName">
				</section>
			</section>
			<!--领票指南-->
			<section v-if="periodsInfo.noticeList.length > 0 &&  periodsInfo.notice==true" class="guide marB1">
				<div class="guide-title">${periodsInfo.noticeTitle}
					<em class="guide-title-arror"></em>
				</div>
				<ul class="guide-ul" var="notice" varStatus="status">
						<li v-for="(item,index) in periodsInfo.noticeList">{{index}}、{{item.text}}</li>
				</ul>
				
				<!--<ul class="guide-ul">
					<c:forEach items="${periodsInfo.noticeList}" var="notice" varStatus="status">
						<li v-if="(item,index) in periodsInfo.noticeList">{{index}}、{{item.text}}</li>
					</c:forEach>
				</ul>-->
				
			</section>
			<!-- 车展活动时间表 -->
			<section  class="marB1 clearfix" v-if="autoShowInfo.activityTimeFlag">
				<div class="titleIn clearfix">
					<span class="titleIn-em-in">
						<em></em>车展活动时间表</span>
				</div>
				<div class="gift-Show clearfix">
					<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+autoShowInfo.activityTimeImg" style="width: 100%;"/>
				</div>
			</section>
			<!-- 精美礼品 -->
			<section v-if="(autoShowInfo.presentList.length) > 0 && autoShowInfo.present==true" class="marB1 clearfix">
				<div class="titleIn clearfix">
					<span class="titleIn-em-in">
						<em></em>{{autoShowInfo.presentTitle}}</span>
				</div>
				<div class="gift-Show clearfix">
					<div class="gift-Show-in">
							<div v-for="(item,index) in autoShowInfo.presentList" class="giftlist-car">
								<em v-if="autoShowInfo.presentTips==true && item.labelType==0" class="register"></em>
								<em v-if="autoShowInfo.presentTips==true && item.labelType==1" class="thecar"></em>
								<em v-if="autoShowInfo.presentTips==true && item.labelType==2" class="prize"></em>
								<a href="javascript:void(0);">
									<div class="clearfix">
										<img class="fl scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName"
										/>
									</div>
									<div class="git-tit">{{item.text}}</div>
								</a>
							</div>
					</div>
				</div>
			</section>
			<!--特权-->
			<section>
				<div class="titleIn clearfix">
					<span class="titleIn-em-in">
						<em></em>报名享受以下特权</span>
					<span class="prompt">一站式购车,省时省力省心</span>
				</div>
				<div class="privilege clearfix">
					<div class="privilegelist01">
						<em class="piao01">票</em>
						<a href="javascript:void(0);">
							<span v-if="isShowTmallUrl != 1">免费</span>领取入场门票</a>
					</div>
					<div class="privilegelist02">
						<em class="piao02"></em>
						<a href="javascript:void(0);">专属购车顾问
							<span v-if="isShowTmallUrl != 1">免费</span>服务</a>
					</div>
					<div class="privilegelist03">
						<em class="piao03"></em>
						<a href="javascript:void(0);">到场购车获赠万元礼包</a>
					</div>
					<div class="privilegelist04">
						<em class="piao04">奖</em>
						<a href="javascript:void(0);">到场购车可参与抽奖</a>
					</div>
				</div>
			</section>
			<!--特权-->
			<!-- 参展品牌 -->
			<section v-if="periodsInfo.exhibitionBrandList.length > 0 && periodsInfo.exhibitionBrand==true" class="brand-table-wrap marB1 backgroundFFF">
				<div class="titleIn brandstyle">
					<span class="titleIn-em-in">
						<em></em>参展品牌</span>
					<!-- <span class="prompt">预计{{periodsInfo.exhibitionBrandList.length}}个品牌参展,持续增加中</span> -->
				</div>
				<ul class="clearfix brand-table">
							<li @click="brandPop($event)" :class="[{'hide':(index>showBrandNum)}]" :style="(index>showBrandNum)?'display:none':''" v-for="(item,index) in periodsInfo.exhibitionBrandList">
								<a class="trackEvent" data-track="carfestivalDetail-4-brandLink" href="javascript:void(0);">
									<p>
										<img v-lazy="commmonWebConfig.picHost+item.brandLogo">
									</p>
									<!-- <input type="hidden" class="js-bshow-id" :value="item.id" /> -->
									<input type="hidden" class="js-bshow-id" value="0" />
									<input type="hidden" class="js-bshow-brandid" :value="item.brandId" />
									<input type="hidden" class="js-bshow-brandlabel" :value="item.label" />
									<p class="hot-brand-tit">{{item.brandName}}</p>
								</a>
							</li>
				</ul>
				<div @click="showAllBrand" v-if="periodsInfo.exhibitionBrandList.length>12" data-track="carfestivalDetail-5-brandMore" id="getmore" class="trackEvent Viewmore">
					<span class="titleIn-more">查看更多
						<em class="iconbtn"></em>
					</span>
				</div>
				<p class="exhibitionbrand-tip">*最终参展品牌以实际到场为准</p>
			</section>
			<!-- 热门优惠 -->
			<section v-if="autoShowInfo.hotDiscountList.length>0 && autoShowInfo.hotDiscount==1" id="rmyhNdy">
					<div class="titleIn">
						<span class="titleIn-em-in">
							<em></em>热门优惠</span>
					</div>
					<div class="preferential">
						<div @click="youhuiPop($event)" v-for="(item,index) in autoShowInfo.hotDiscountList" :key="index">
							<a :class="['trackEvent',{'current':(autoShowInfo.hotDiscountList.length < 4)}]" data-track="carfestivalDetail-6-certificateLink" href="javascript:void(0);">
								<img class="scrollLoading" :src="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName">
							</a>
							<input type="hidden" class="js-dis-id" value="item.id">
							<input type="hidden" class="js-dis-title" value="item.title">
							<input type="hidden" class="js-dis-brandid" value="item.brandId">
							<input type="hidden" class="js-dis-text" value="item.text">
						</div>
						<div v-if="autoShowInfo.hotDiscountList > 3" data-track="carfestivalDetail-7-certificateMore" id="packup" class="trackEvent Viewmore">
							<span class="titleIn-more">查看更多
								<em class="iconbtn"></em>
							</span>
						</div>
					</div>
			</section>
			<!-- 交通攻略 -->
			<section class="marB1 addresswrap clearfix">
				<div class="titleIn">
					<span class="titleIn-em-in">
						<em></em>交通攻略</span>
				</div>
				<div class="RoadGuide clearfix">
					<img class="scrollLoading" :src="commmonWebConfig.static+'/img/carfestival/address01.png'">
					<div class="top-add">
						<span class="road-title">车展地址</span>
					</div>
					<div class="right-nav">
							<a v-if="periodsInfo.longitudeLatitude != null" data-track="carfestivalDetail-8-gps" class="trackEvent gps" :href="'//uri.amap.com/marker?position'+periodsInfo.longitudeLatitude+'&name='+periodsInfo.title+'&src=tuanche&coordinate=gaode&callnative=0'">
								<em class="navicon"></em>
								<span class="font-red">导航</span>
							</a>
					</div>
				</div>
				<div class="blacksize">{{periodsInfo.address}}</div>
				<div v-if="jtResultMap != {}">
					<div v-if="typeof(jtResultMap.bus) != 'undefined'" class="twoadd">
						<div class="lines">
							<img class="scrollLoading" :src="commmonWebConfig.static+'/img/carfestival/icon-bus.png'">
							<p class="road-title">公交:</p>
						</div>
						<div class="promptadd">
							<p class="point">{{jtResultMap.bus}}</p>
						</div>
					</div>
					<div v-if="typeof(jtResultMap.subway) != 'undefined'" class="metro">
						<div class="underground">
							<img class="scrollLoading" :src="commmonWebConfig.static+'/img/carfestival/icon-underground.png'">
							<p class="road-title">地铁:</p>
						</div>
						<div class="threeadd">
							<p class="point">{{jtResultMap.subway}}</p>
						</div>
					</div>
				</div>
			</section>
			<!-- 服务保障 -->
			<promiseComponentNew></promiseComponentNew>
			<!-- 新闻报道开始 -->
			<section v-if="autoShowInfo.news==1" class="marB1 backgroundFFF clearfix">
				<div class="titleIn clearfix">
					<span class="titleIn-em-in">
						<em></em>新闻报道</span>
				</div>
				<div class="newwrap">
						<iframe v-if="autoShowInfo.newsVideolink != null" data-track="carfestivalDetail-9-video" id="youkuIframe" class="trackEvent youkuIframe" width="100%" :src='autoShowInfo.newsVideolink'
						 frameborder="0"></iframe>
						<!-- 轮播 -->
						<div v-if="autoShowInfo.newsList.length>0" class="swiper-container">
							<div id="swiper-wrapper" class="swiper-wrapper">
									<div v-for="(item,index) in autoShowInfo.newsList" class="swiper-slide">
										<img :src="commmonWebConfig.static+'/img/common/blank3-2.gif'" :sur-src="autoShowInfo.picUrl+item.imageName">
									</div>
							</div>
						</div>
						<!-- 轮播 -->
				</div>
				<div class="newsize">
					{{autoShowInfo.newsDesc}}
				</div>
			</section>
			<!-- 往期回顾 -->
			<div v-if="autoShowInfo.freedomList.length > 0">
				<section v-if="item.style==1"  v-for="(item,index) in autoShowInfo.freedomList" class="clearfix marB1 backgroundFFF">
					<div class="titleIn">
						<span class="titleIn-em-in">
							<em></em>{{item.title}}</span>
					</div>
					<div class="modelwrap">
						<div class="left-img">
							<a class="clearfix" href="javascript:void(0);">
								<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.img1">
							</a>
							<a class="clearfix model-btn" href="javascript:void(0);">
								<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.img2">
							</a>
						</div>
						<div class="right-img">
							<a href="javascript:void(0);">
								<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.img3">
							</a>
						</div>
					</div>
				</section>
				<section v-if="item.style==2"  v-for="(item,index) in autoShowInfo.freedomList" class="marB1 backgroundFFF">
					<div class="titleIn">
						<span class="titleIn-em-in">
							<em></em>item.title</span>
					</div>
					<div class="lookback clearfix">
						<ul>
							<li>
								<a href="javascript:void(0);">
									<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.img1">
								</a>
							</li>
							<li>
								<a href="javascript:void(0);">
									<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.img2">
								</a>
							</li>
							<li>
								<a href="javascript:void(0);">
									<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.img3">
								</a>
							</li>
						</ul>
					</div>
				</section>
				
			</div>
			<!-- 底部图片 -->
			<section>
				<div class="footerimg">
					<!--<a href="#showTime">-->
					<a href="javascript:void(0);">	
						<img class="scrollLoading" v-lazy="commmonWebConfig.static+'/img/carfestival/footer-banner.png'">
					</a>
				</div>
			</section>
			<!-- 蒙层弹窗 -->
			<div class="pop-mark"></div>
			<div class="markwrap">
				<form id="myform" class="myform">
					<div id="markdel" class="markdel"></div>
					<div id="money01" class="money01"></div>
					<div id="money02" class="money02"></div>
					<div id="money03" class="money03"></div>
					<div id="money04" class="money04"></div>
					<div id="money05" class="money05"></div>
					<div class="popup">
						<div class="inputwrap">
							<input type="hidden" id="telval">
							<input type="hidden" id="brandval">
							<input type="hidden" id="posval">
							<input type="hidden" id="msgval" />
							<input type="hidden" id="titleval" />
							<input type="tel" maxlength="11" placeholder="请输入您的手机号" class="phone">
						</div>
						<div class="inputwrap code-warp">
							<input id="pop-code" type="tel" placeholder="请输入验证码" class="code">
							<button type="button" class='code-btn' id="pop-code-btn">获取验证码</button>
						</div>
						<div class="pop-lucencywrap">
							<div @click="subApplyPopBrand()" :class="['signupnow',{'noclick':isMaskclick}]">立即报名</div>
						</div>
						<div style="color:#f0f0f0; margin-top:0.5em" class="addxyroom">*请放心填写,报名即视为同意<a style="color:#fff;" href="javascript:void(0);" class="addxydetail" @click="addxydetail">《个人信息保护声明》</a> </div>
						<div class="pop-luc-discounts">
							<div class="signupnow" id="js-discount">领取优惠</div>
						</div>
					</div>
					<!-- <div class="font-size js-text-show" id="font-size"></div> -->
					<div class="font-size" id="preferential">
						优惠使用说明：
						<br> 1、该优惠券将以短信形式发送到您的手机，请注意查收
						<br> 2、此券自领取时间起一个月内有效，逾期不可使用
						<br> 3、领取该优惠券的用户需在有效期内到指定地点购车并使用该券
						<br> 4、在满足使用条件的前提下，单笔订单最多使用一张优惠券
						<br> 5、本优惠券不可兑换现金
						<br> 6、本次活动最终解释权归团车互联网信息服务（北京）有限公司所有
					</div>
				</form>
			</div>
			<!-- 主办方 -->
			<section>
				<div class="clearfix twosponsorwrap">
					<div class="sponsor01">
						<div class="centericon">
							<span class="center-title">主办方:</span>
							<div class="clearfix iconlist">
								<em>
									<img class="scrollLoading" src="//static3.tuanche.com/wap2017/dist/img/carfestival/logo.png"/>
								</em>
							</div>
						</div>
					</div>
				</div>
			</section>






			<!-- 底部 -->
			<footerComponent></footerComponent>
			<!--协议-->
			<agreementComponent></agreementComponent>
			<!--协议-->
		</div>
		
		<!--在线客服 s-->
		<!-- <div class="onlineservice">
			<div class="iconwrap"></div>
			<div class="moreCar">更多车展详情</div>
			<div class="buttonClick">点击咨询</div>
		</div>
		<div class="onlineperson"></div> -->
		<!--在线客服 end-->
		<!-- 侧拉品牌 -->
		<div id="sider-mark" class="sider-mark"></div>
		<div id="sider-wrap" class="sider-wrap">
			<div id="side-brand" class="side-div side-brand">
				
			</div>
			<div id="side-carstyle" class="side-div side-carstyle">
			</div>
		</div>
		<div id="adPop-mark" class="adPop-mark"></div>
		<div id="adPop" class="signUpfrom adPop">
			<div class="adPop-tit">请先选择您中意的车型</div>
			<form id="signUpfromPop">
				<div class="signUpform-com">
					<em class="signUpfrom-icon signUpfrom-icon01"></em>
					<input id="userNamePop" name="userName" placeholder="请输入姓名" class="signUpfrom-txt userName" type="text" maxlength="10" />
				</div>
				<div class="signUpform-com">

					<em class="signUpfrom-icon signUpfrom-icon02"></em>
					<input id="telphonePop" name="telphone" placeholder="请输入手机号码" class="signUpfrom-txt telphone" type="tel" maxlength="11" />
				</div>
				<div class="signUpform-com">
					<em class="signUpfrom-icon signUpfrom-icon03"></em>
					<div @click="getData($event)" id="insertCarPop" class="signUpfrom-txt">请输入意向品牌和意向车型</div>
					<em class="icon-arror-r"></em>
				</div>
				<div id="adPopBtn" class="adPopBtn">
					下一步
				</div>
			</form>
		</div>

	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.mint-swipe{
		height:5.333333rem;
		.swiper-img{
			width:10rem;
			height:5.333333rem;
		}
	}
	    
	.brand-table {
		border-right: 1px solid #e5e5e5;
    	border-top: 1px solid #e5e5e5;
		li{
			float: left;
			width:33.3333%;
			text-align: center;
	    	background: #fff;
	    	
	    	a{
	    		display: block;
	    		border-left: 1px solid #e5e5e5;
	    		border-bottom: 1px solid #e5e5e5;
			    padding: 0.6em 0;
			    text-decoration: none;
	    		img{
	    		    width: 1.066667rem;
	    			height: 1.066667rem;
	    		}
	    	}
	    	

		}
		li.hide{
			display: none;
		}
	}
	.noclick{
		pointer-events: none;
	}
</style>
<script>
function trackerAD(accountId) {
	TDH5SDK.account.register(accountId, null, null, null, null, null);
}

//import data from "@/data/data.js"
import { Toast } from 'mint-ui';
export default {
	name: 'index',
	data:function() {
		return {
			bodyIsShow:false,
			showAddress:-1,
			city:{
				name:"北京"
			},
			autoShowInfo:{
				applyprocessList:[],
				showApplyprocess:true,
				showCountdown:true,
				showApplynum:false,
				activityTimeImg:null,
				activityTimeFlag:null,
				present:false,
				presentTitle:"jhfjds",
				presentTips:false,
				presentList:[],

				picUrl:"",

				hotDiscount:1,
				hotDiscountList:[],
				news:null,
				newsVideolink:null,
				newsDesc:"",
				newsList:[],
				freedom:-1,
				freedomList:[],
				dealerList:[],

				tAutoshowPeriodsOcpc:null

			},
			deadline:10000,
			isShowTmallUrl:1,

			periodsInfo:{
				id:"",
				ticketPrice:20,
				noticeTitle:"而且有日期",
				notice:null,
				noticeList:[],
				exhibitionBrand:true,
				exhibitionBrandList:[],
				longitudeLatitude:null,
				title:"",
				address:"",
				qrcodeImg:"",
				weixin:""
			},
			jtResultMap:{},
			adSpaceObj:null,
			cityId: '10',
			appPersonNum:0,
			applyListMap:[],
			showBrandNum:11,
			ocpcId:"",
			periodsType:'1',
			isclick:false,
			isMaskclick:false
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/carfestival/detail.css"
		});
	},
	mounted:function(){
		var self = this;

		
		//引入私有的js
		getCommonJsIns.initDefaultJS(self.webReady);
		
		
		//统计
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');



	    /*添加tracking_sdk统计代码*/
		var script=document.createElement('script');
        script.type="text/javascript";
        script.id = "td_tracking_sdk";
        script.vn = "1";
        script.vc = "2";
        script.src = this.commmonWebConfig.static+"/js/stat/build/load.min.js?ak=32F583CFF4DD44308125FF29548E1F2F";
        document.body.appendChild(script);
        

		
		String.prototype.GetValue = function (para) {
			var reg = new RegExp("(^|&)" + para + "=([^&]*)(&|$)");
			var r = this.substr(this.indexOf("\?") + 1).match(reg);
			if (r != null && r[2].indexOf("#") > 0) {
				r[2] = r[2].substring(0, r[2].indexOf("#"));
			}
			if (r != null) return decodeURI(r[2]); return null;
		};

		/*添加tracking_sdk统计代码*/

		/***统计添加**/
		!function(e, t, n, g, i) {
		    e[i] = e[i] || function() { 
		    	(e[i].q = e[i].q || []).push(arguments)
		    };
		    var n = t.createElement("script");
		    var tag = t.getElementsByTagName("script")[0];
		    n.async = 1;
		    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
		    tag.parentNode.insertBefore(n, tag);
		} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
		gio('init', '8004d11f5708cccc', {});
		//custom page code begin here
		//custom page code end here
		gio('send');
		gio('enableHT', 'true');
		/***统计添加**/

		/*******************OCPC统计代码********************/
		window._agl = window._agl || [];
        (function () {
            _agl.push(
                ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
            );
            (function () {
                var agl = document.createElement('script');
                agl.type = 'text/javascript';
                agl.async = true;
                agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(agl, s);
            })();
        })();
		/*******************OCPC统计代码********************/
	},
	methods:{
		tojiIcpc:function(ocpcId){
			var ocpcId = ocpcId;
			(function (root) {
			    root._tt_config = true;
			    var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
			    ta.src = document.location.protocol + '//' + 's3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
			    ta.onerror = function () {
			        var request = new XMLHttpRequest();
			        var web_url = window.encodeURIComponent(window.location.href);
			        var js_url = ta.src;
			        var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=' + ocpcId;
			        request.open('GET', url, true);
			        request.send(null);
			    }
			    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ta, s);
			})(window);
		},
		addxydetail: function() {
			agreementUtil.agreement.init();
		},
		webReady:function(){
			var self = this;
			//console.log($.base64.btoa);
			if(self.$route.query.activityType){
				self.periodsType=self.$route.query.activityType;
			}
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcj+"/"+this.$route.params.cityPy+"?periodsType="+self.periodsType,
				//url:"http://oo.tuanche.com:8083/data/data.js"
				async:false,
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						self.bodyIsShow = true;
						self.showAddress = result.address;
						self.autoShowInfo.headerImg = result.concentMap.autoShowInfo.headerImg;
						self.autoShowInfo.applyprocessList = result.concentMap.autoShowInfo.applyprocessList;
						self.autoShowInfo.showApplyprocess =  result.concentMap.autoShowInfo.showApplyprocess;
						self.autoShowInfo.showCountdown = result.concentMap.autoShowInfo.showCountdown;
						self.autoShowInfo.activityTimeImg = result.concentMap.autoShowInfo.activityTimeImg;
						self.autoShowInfo.activityTimeFlag = result.concentMap.autoShowInfo.activityTimeFlag;
						if(result.periodsInfo.showTmallUrl){
							self.autoShowInfo.isShowTmallUrl = result.periodsInfo.showTmallUrl;
						}
						if(typeof(result.concentMap.adSpaceObj) != "undefined"){
							self.adSpaceObj = result.concentMap.adSpaceObj
						}
						self.autoShowInfo.showApplynum = result.concentMap.autoShowInfo.showApplynum;

						self.autoShowInfo.present = result.concentMap.autoShowInfo.present,
						self.autoShowInfo.presentTitle = result.concentMap.autoShowInfo.presentTitle,
						self.autoShowInfo.presentTips = result.concentMap.autoShowInfo.presentTips,
						self.autoShowInfo.presentList = result.concentMap.autoShowInfo.presentList;
						self.autoShowInfo.picUrl = result.concentMap.autoShowInfo.picUrl;

						self.autoShowInfo.hotDiscount = result.concentMap.autoShowInfo.hotDiscount;
						self.autoShowInfo.hotDiscountList = result.concentMap.autoShowInfo.hotDiscountList;

						self.autoShowInfo.news = result.concentMap.autoShowInfo.news;
						self.autoShowInfo.newsVideolink = result.concentMap.autoShowInfo.newsVideolink;
						self.autoShowInfo.newsDesc = result.concentMap.autoShowInfo.newsDesc;
						self.autoShowInfo.newsList = result.concentMap.autoShowInfo.newsList;

						self.autoShowInfo.freedom = result.concentMap.autoShowInfo.freedom;
						self.autoShowInfo.freedomList = result.concentMap.autoShowInfo.freedomList;
						self.autoShowInfo.tAutoshowPeriodsOcpc = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc;
						if(result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc!=null){
							self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
							self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal;
							self.tojiIcpc(self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId);

						};
						self.appPersonNum = result.concentMap.appPersonNum;
						self.applyListMap = result.applyListMap;
						self.periodsInfo.id = result.periodsInfo.id;
						self.periodsInfo.ticketPrice = result.periodsInfo.ticketPrice;
						self.periodsInfo.notice = result.periodsInfo.notice;
						self.periodsInfo.noticeList = result.periodsInfo.noticeList;
						self.periodsInfo.exhibitionBrand = result.periodsInfo.exhibitionBrand;
						self.periodsInfo.exhibitionBrandList = result.periodsInfo.exhibitionBrandList;
						self.periodsInfo.longitudeLatitude = result.periodsInfo.longitudeLatitude;
						self.periodsInfo.title = result.periodsInfo.title;
						self.periodsInfo.address = result.periodsInfo.address;
						self.periodsInfo.qrcodeImg = result.periodsInfo.qrcodeImg;
						self.periodsInfo.weixin = result.periodsInfo.weixin;
						self.periodsType = result.periodsInfo.activityType;
						document.title=result.periodsInfo.title;
						


						if(typeof(result.concentMap.bus) != "undefined"){
							self.jtResultMap.bus = result.concentMap.bus;
						}
						if(typeof(result.concentMap.subway) != "undefined"){
							self.jtResultMap.subway = result.concentMap.subway;
						}
						self.deadline = result.concentMap.deadline;

						window.cityId = result.periodsInfo.cityId;
						window.py = self.$route.params.cityPy;
						window.weChatShareData = { py: py, shareType: 'hmtcj' };
						// window.addressType = 2;
						// window.indexInstalments = '0';
						// window.indexOtherbrand = '0';
						// window.indexNewbyV = '0';
						//引进私有文件
						getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/carfestival/detailNew.js",function(){
							//console.log(self.periodsInfo);
							}
						);
						
					}else{
						// self.$router.push({path: '/hmtcj/end'});
						if(data.response.result.cityId){
							window.cityId = data.response.result.cityId;
						}else{
							window.cityId = self.cityId;
						}
            			window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;

					}
				},
				error:function(data){
					if(data.response.result.cityId){
						window.cityId = data.response.result.cityId;
					}else{
						window.cityId = self.cityId;
					}
					window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
				}
			});
			
		},
		showAllBrand:function(){
			if(this.showBrandNum == 11){
				this.showBrandNum = this.periodsInfo.exhibitionBrandList.length;
			}else{
				this.showBrandNum = 11;
			}	
		},
		youhuiPop:function(event){
			var obj = event.target;
			$(".pop-mark").css({
				position: "fixed",
				display: 'block',
				height: "100%",

			});
			$("#sin-lucency").hide();
			$("#sigdiscounts").show();
			$("#tikect-btn-fixed").hide();
			$("#font-size").hide();
			$("#js-brand").hide();
			$(".markwrap").show();
			$("#js-discount").show();
			$("#preferential").show();
			$("#font-size").hide();
			var surval = $(obj).find('.js-dis-id').val();
			var curval = $(obj).find('.js-dis-brandid').val();
			var titleval = $(obj).find('.js-dis-title').val();
			var msgval = $(obj).find('.js-dis-text').val();
			$("#telval").val(surval); //优惠id
			$("#brandval").val(curval); //优惠品牌id
			$("#titleval").val(titleval); //优惠标题
			$("#msgval").val(msgval); //优惠短信
			$("#posval").val(2); //位置
			var cookieval = webCommonUtil.cookie.getCookie("tcjphone");
			$(".phone").val(cookieval); //放到页面
		},
		getData: function(event) {
			var self = this;
			webCommonUtil.getBrandCarStyle.init({
				domObj: event.target,
				callback: function() {
					//console.log($("#aa").data("carstyleiName"));
				},
				ajaxBrandParams: {
					url: this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.tcBrand,
					type: "post",
					dataType: "json",
					async: false,
					data: {
						cityId: self.cityId
					},
				},
				ajaxCarStyleParams: {
					url: this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.baseDataTcStyle,
					type: "post",
					dataType: "json",
					async: false,
					data: {
						cityId: self.cityId
					}
				},
				changeFontColor:"#333"
			});
		},
		brandPop:function(event){
			var obj = event.currentTarget;
			$(".pop-mark").css({
				position: "fixed",
				display: 'block',
				height: "100%",

			});
			$("#sigdiscounts").hide();
			$("#sin-lucency").show();
			$("#tikect-btn-fixed").hide();
			$("#font-size").show();
			$("#preferential").hide();
			$(".markwrap").show();
			$("#js-brand").show();
			$("#js-discount").hide();
			var surval = $(obj).find('.js-bshow-id').val();
			var curval = $(obj).find('.js-bshow-brandid').val();
			var fontsize = $(obj).find('.js-bshow-brandlabel').val();
			if(fontsize != "") {
				$("#font-size").html(fontsize).show();
			} else {
				$("#font-size").hide();
			};
			//console.log("fontsize:"+fontsize);

			$("#telval").val(surval);
			$("#brandval").val(curval);
			// 获取缓存
			var cookieval = webCommonUtil.cookie.getCookie("tcjphone");
			// alert(cookieval);
			$(".phone").val(cookieval); //放到页面
			$("#posval").val(3);
		},
		subApply:function(data){
			var self = this;
			//添加报名经纬度
			if("undefined" != typeof positionMap) {
				dataApply.locations = positionMap;
				logImg($("#telphone").val());
			};
			//疑似恶意报名，增加短信验证码
			if($(".code-warp").is(":visible")) {
				dataApply.checkCode = $("#code").val();
			};
			$("#tikect-sub").attr("disabled","disabled");
			$("#signUpButton").attr("disabled","disabled");
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
				type:"post",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){
						$("#tikect-sub").removeAttr("disabled");
						$("#signUpButton").removeAttr("disabled");
						self.isclick=false;
						self.isMaskclick=false;
						// console.log(data);
						if(data.response.result.code == 10000) {
							var c = document.location.href.GetValue("c");
							if(self.autoShowInfo.tAutoshowPeriodsOcpc != null && c == self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal) {
								var id = self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
								if(id != "") {
									_taq.push({
										convert_id: id,
										event_type: "form"
									});
								}
							}
							trackerAD(data.response.result.applyId);
							//写缓存                           
							webCommonUtil.cookie.addCookie("tcjphone", $("#telphone").val(), 1);
							// if(tmallUrl) {
							// 	Toast({
				   //                message: "领票成功,即将进入天猫权益购买页面",
				   //                position: 'middle',
				   //                duration: 2000
				   //              });
							// 	setTimeout(function() {
							// 		window.location.href = tmallUrl;
							// 	}, 3000);
							// } else {
								// console.log(data.response.result);
								// //return;
								// //跳转到完善信息页面 
								// function GetUrlStr(){
						  //          var url = location.search; //获取url中"?"符后的字串
						  //          alert(url);
						  //          var str = "";
						  //          if (url.indexOf("?") != -1) {
						  //             str = url.substr(1);
						  //          }
						  //          return str;
						  //       } 
								// var webC = GetUrlStr();
								// alert(webC) ;                       					  
								window.location.href ="/hmtcj/applySupplement?address="+$("#showAddress").val()+"&applyId=" + data.response.result.result.applyId + "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" + $('#groupbyNum').val()+"&cityId="+cityId+"&sk="+data.response.result.result.sk;

							//}
							$("#tikect-sub").removeAttr("disabled");

						} else if(data.response.result.code == -99999) {
							$(".code-warp").show();
						} else {
							Toast({
			                  message: data.response.msg,
			                  position: 'middle',
			                  duration: 2000
			                });
						}

					}
					
				},
				error:function(){
					$("#tikect-sub").removeAttr("disabled");
					$("#signUpButton").removeAttr("disabled");
					self.isclick=false;
					self.isMaskclick=false;
					Toast({
	                  message: "系统忙，请稍后",
	                  position: 'middle',
	                  duration: 2000
	                });
				}
			});
		},
		subApplyPopBrand:function(){
			var self = this;
			var mobileReg = /^[1][0-9]{10}$/;
			var mobileNum = $.trim($(".phone").val());
			$("#js-brand").attr("disabled", "disabled");
			var buyType = "";
			var splitMoney = "";
			var otherbrand = "";
			// if(indexNewbyV == 1) { //多选
			// 	$('#lastmask-check').find('.active').each(function() {
			// 		if($(this).attr("data-type") == 'fq') {
			// 			splitMoney = "1";
			// 		} else if($(this).attr("data-type") == 'zh') {
			// 			buyType = "1";
			// 		}
			// 	});
			// } else { //单选
			// 	if($("#mask-cartype").find('.active').attr("data-buytype")) {
			// 		buyType = $("#mask-cartype").find('.active').attr("data-buytype");
			// 	}
			// 	if($("#bystages").find('.active').attr("data-splitmoney")) {
			// 		splitMoney = $("#bystages").find('.active').attr("data-splitmoney");
			// 	}
			// 	if($("#restcay").find('.active').attr("data-otherbrand")) {
			// 		otherbrand = $("#restcay").find('.active').attr("data-otherbrand");
			// 	}
			// }
			if(!mobileReg.test(mobileNum)) {
				Toast({
                  message: "请输入11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
				return false;

			} else if($(".code-warp").is(":visible") && $.trim($("#pop-code").val()).length != 4) {
				Toast({
                  message: "请输入4位验证码",
                  position: 'middle',
                  duration: 2000
                });
				return false;
			} else {
				var data = {
					"sourceUrl": window.location.href,
					"cityId": cityId,
					"name": $("#userName").val(),
					"phone": $(".phone").val(),
					"groupbyNum": $('#groupbyNum').val(),
					"position": $("#posval").val(),
					"groupbyType": self.periodsType,
					"buyType": buyType,
					"splitMoney": splitMoney,
					"otherBrand": otherbrand,
					"brandId": $("#brandval").val(),
					"checkIp": true,
					"sourceId":'-1',
					"bmtype":'autoshow_apply'
					
				};
				self.isMaskclick=true;
				self.subApply(data);
				$("#js-brand").attr("disabled", "disabled");
			}
		},
		subApplyBtn:function(objId){
			var self = this;
			var buyType = "";
			var splitMoney = "";
			var otherbrand = "";
			// if(indexNewbyV == 1) { //多选
			// 	$('#lastmask-check').find('.active').each(function() {
			// 		if($(this).attr("data-type") == 'fq') {
			// 			splitMoney = "1";
			// 		} else if($(this).attr("data-type") == 'zh') {
			// 			buyType = "1";
			// 		}
			// 	});
			// } else { //单选
				// if($("#mask-cartype").find('.active').attr("data-buytype")) {
				// 	buyType = $("#mask-cartype").find('.active').attr("data-buytype");
				// }
				// if($("#bystages").find('.active').attr("data-splitmoney")) {
				// 	splitMoney = $("#bystages").find('.active').attr("data-splitmoney");
				// }
				// if($("#restcay").find('.active').attr("data-otherbrand")) {
				// 	otherbrand = $("#restcay").find('.active').attr("data-otherbrand");
				// }
			//}
			var relF = $("#side-carstyle").data("dada");
			
			var rel = relF!=null && relF.split("@#");
			// if(($("#insertCar").text()) == "请选择意向品牌和意向车型") {
			//  	Toast({
            //       message: "请选择意向品牌和意向车型",
            //       position: 'middle',
            //       duration: 2000
            //     });
			// 	return false;
			// }else 
			if($("#userName").val()=='' || !webCommonUtil.commonFun.isName($("#userName").val())){
				Toast({
                  message: "请填写真实姓名",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(!webCommonUtil.commonFun.isPhone($("#telphone").val())){
				Toast({
                  message: "请填写11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else{
				var dataApply = {
					"sourceUrl": window.location.href,
					"cityId": cityId,
					"name": $("#userName").val(),
					"phone": $("#telphone").val(),
					"groupbyNum": $('#groupbyNum').val(),
					"position": $("#position").val(),
					"groupbyType": self.periodsType,
					"brandId": rel[0],
					"carStyleId": rel[1],
					"paperTicketAddress": $("#address").val(),
					"checkIp": false,
					"sourceId":'-1',
					"bmtype":'autoshow_apply'
				};
				dataApply["brandId"]=$(objId).data("brandId"),
				dataApply["carStyleId"]= $(objId).data("carstyleId"),
				// if(relF && !$("#tikect-sub").hasClass("subDisabled")) {
				// 	$("#tikect-sub").addClass("subDisabled");
					self.isclick=true;
					self.subApply(dataApply);
				// } else {
				// 	$("#insertCar").text("");
				// 	Toast({
	            //       message: "请输入意向品牌和意向车型",
	            //       position: 'middle',
	            //       duration: 2000
	            //     });
				// }
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carfestival/detail.vue